import { Injectable } from '@angular/core';
import { ZoneProperties } from 'src/app/model/zone-properties';
import { ZONES_PROPERTIES } from 'src/app/data/zones-properties';
import { Subject } from 'rxjs';
import { ZONE_PROPERTIES_DEFAULT } from '../data/zones-properties.1';
import { DataService } from './data.service';
import { ElementsService } from './elements.service';
import { SCALE } from '../data/scale';
import { ZONES_TYPES } from '../data/elements';

@Injectable({
  providedIn: 'root'
})
export class ZonesPropertiesService {
  
  private _zonesPropertiesSource: Subject<ZoneProperties[]> = new Subject();
  private _currentZonesProperties: ZoneProperties[];
  zonesProperties$ = this._zonesPropertiesSource.asObservable();

  
  constructor(
    // private dataService: DataService
  ) {    
    this._currentZonesProperties=ZONES_PROPERTIES;
   }

   get zonesPropertiesSource(): Subject<ZoneProperties[]> {
    return this._zonesPropertiesSource;
  }
  set zonesPropertiesSource(data: Subject<ZoneProperties[]>) {
    this._zonesPropertiesSource = data;
  }

  get zonesProperties() : ZoneProperties[]{
    
    return this._currentZonesProperties;
  }

  getZoneProperties(id:number){
    for(let i=0;i<this._currentZonesProperties.length;i++){
      if(this._currentZonesProperties[i].id==id)
        return this._currentZonesProperties[i]
    }
  }

  getProperties(id:number){
    for(let i=0;i<this._currentZonesProperties.length;i++){
      if(this._currentZonesProperties[i].id==id)
        return this._currentZonesProperties[i]
    }
    return null;
  }

  getPropertiesIndex(id:number){
    for(let i=0;i<this._currentZonesProperties.length;i++){
      if(this._currentZonesProperties[i].id==id)
        return i
    }
    return null;
  }


  removeZoneProperty(id){
    let index=this.getPropertiesIndex(id);
    this._currentZonesProperties.splice(index,1);
    this.zonesPropertiesSource.next(this._currentZonesProperties)
  }

  addZone(zone){
      if(this.getProperties(zone.id)){
      }else{
        // let area = this.dataService.calculateArea(this.elementService)
        let z=JSON.parse(JSON.stringify(ZONE_PROPERTIES_DEFAULT));
        z.id=zone.id;
        z.type=zone.type;
        z.name=zone.name;
        z.color=zone.color;
        z.textColor=zone.textColor;
        this._currentZonesProperties.push(z)
      }
    this.zonesPropertiesSource.next(this._currentZonesProperties)
  }

  addZones(zones){
    
    for(let i=0;i<zones.length;i++){
      if(this.getProperties(zones[i].id))
        continue;
      else{
        let zone=JSON.parse(JSON.stringify(ZONE_PROPERTIES_DEFAULT));
        zone.id=zones[i].id;
        zone.type=zones[i].type;
        zone.name=zones[i].name;
        zone.color=zones[i].color;
        zone.textColor=zones[i].textColor;
        this._currentZonesProperties.push(zone)
      }
    }
    this.zonesPropertiesSource.next(this._currentZonesProperties)
  }
  appendNames(contour,zones){
    let currZones=this._currentZonesProperties;  
    
    let index=this.getPropertiesIndex(-1)
    let area=0;
    if(contour!=undefined)
      area= contour.area //.toFixed(2); //this.calculateArea(contour.points)

    currZones[index].name='Global - '+area+'m²'

    area=0;
    if(zones!=undefined)
      for(let i=0;i<zones.length;i++){
        let index=this.getPropertiesIndex(zones[i].id)
        area= zones[i].area //.toFixed(2); //this.calculateArea(zones[i].points)
        let zoneName=this.getZoneTypeById(zones[i].type)
        currZones[index].name=zoneName.name+' ('+this.getZoneTypeNumber(zones,zones[i])+') - '+area+'m²';
        currZones[index].type=zones[i].type;
        
      }
    this.zonesPropertiesSource.next(currZones)
  }

  getZoneTypeNumber(zones,zone){
    let count:number=this.countZonesByType(zones,zone)
    return ++count;
  }

  countZonesByType(zones,zone){
    let amount=0;
    
    for(let i=0;i<zones.length;i++){
      if(zones[i].id==zone.id)
        break;
      if(zones[i].type==zone.type)
        amount++;
    }
    return amount;
  }

  getZoneTypeById(id){
    for(let i=0;i<ZONES_TYPES.length;i++){
      if(ZONES_TYPES[i].val==id)
        return ZONES_TYPES[i];
    }
  }

  setZonesDefaults(zones=null){
    let currZones=this._currentZonesProperties;  
    for(let i=0;i<currZones.length;i++){
      if(currZones[i].type==1){
        currZones[i].pointLoad.ifActive=true;
        currZones[i].pointLoad.selected=650;
        
        currZones[i].compresiveStrength.ifActive=true;
        currZones[i].compresiveStrength.selected=65;
      }else if(currZones[i].type==2){
        currZones[i].pointLoad.ifActive=true;
        currZones[i].pointLoad.selected=2000;
        
        currZones[i].compresiveStrength.ifActive=true;
        currZones[i].compresiveStrength.selected=175;
      }else if(currZones[i].type==4){
        currZones[i].pointLoad.ifActive=true;
        currZones[i].pointLoad.selected=650;
        
        currZones[i].compresiveStrength.ifActive=true;
        currZones[i].compresiveStrength.selected=65;
      }else if(currZones[i].type==0 || currZones[i].type==3 || currZones[i].type==4){
        if(currZones[i].acoustic.ifActive == true || currZones[i].rainNoise.ifActive == true ){
          currZones[i].pointLoad.ifActive=true;
          currZones[i].pointLoad.selected=650;
          
          currZones[i].compresiveStrength.ifActive=true;
          currZones[i].compresiveStrength.selected=65;
        }
      }

    }
    this.zonesPropertiesSource.next(currZones)
  }

}
